import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=0ec00fde&scoped=true&"
import script from "./Sorter.vue?vue&type=script&lang=js&"
export * from "./Sorter.vue?vue&type=script&lang=js&"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=0ec00fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec00fde",
  null
  
)

export default component.exports